class QueryOrdersPaymentsManagement {
    constructor(fechaDesde, fechaHasta, estado, importeDesde, importeHasta, concepto, fechaAltaDesde, fechaAltaHasta) {
        this.fechaDesde = fechaDesde;
        this.fechaHasta = fechaHasta;
        this.estado = estado;
        this.importeDesde = importeDesde;
        this.importeHasta = importeHasta;
        this.concepto = concepto;
        this.fechaAltaDesde = fechaAltaDesde;
        this.fechaAltaHasta = fechaAltaHasta;
    }
}

export default QueryOrdersPaymentsManagement;